import { useRef } from 'react';
import { imagePlugin } from './image';
import classnames from 'classnames';
import imageIcon from '@sb1/ffe-icons/icons/open/300/md/image.svg';
import { Icon } from '@sb1/ffe-icons-react';
import { Tooltip } from '../tooltip/Tooltip';

const { addImage } = imagePlugin;

const ImageMenuItem = ({ uploadImage, style = '', theme, updateEditorState, editorState }) => {
    const fileInput = useRef(null);

    const styleIsActive = () => {
        if (editorState) {
            return editorState.getCurrentInlineStyle().has(style);
        }
    };

    const onClick = (e) => {
        e.preventDefault();
        fileInput?.current?.click();
    };

    const inputChange = (e) => {
        const file = e.target.files[0];

        if (file) {
            uploadFile(file);
        }
    };

    const uploadFile = (file) => {
        if (!file?.type?.includes('image/')) {
            return;
        }

        if (uploadImage) {
            uploadImage(file)
                .then(({ src }) => {
                    const newEditorState = addImage(editorState, src);
                    return updateEditorState(newEditorState);
                })
                .catch(() => {});
        } else {
            const src = window.URL.createObjectURL(file);
            const newEditorState = addImage(editorState, src);
            return updateEditorState(newEditorState);
        }
    };

    return (
        <>
            <Tooltip text="Sett inn bilde">
                <button
                    className={classnames({
                        [theme?.active]: styleIsActive(),
                        [theme?.button]: true,
                    })}
                    onClick={onClick}
                    onMouseDown={(e) => e.preventDefault()}
                >
                    <Icon fileUrl={imageIcon} />
                </button>
            </Tooltip>
            <input
                type="file"
                ref={fileInput}
                accept=".jpg,.jpeg,.png,.webp"
                value=""
                onChange={inputChange}
                style={{ display: 'none' }}
            />
        </>
    );
};
export default ImageMenuItem;
